import React from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {setStateLeftAsideMenu} from "../../store/globalState/actionCreators/globalState_AppActionCreator";

class MobileMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.toggleLeftMenu = this.toggleLeftMenu.bind(this);
    }

    toggleLeftMenu() {
        /* TODO КН 17.11.23 Перенес логику стрелки из LeftMenu.js */
        let rootName = !this.props.isSearch ? this.props.rootName : null
        if (this.props.isSearch) this.props.setStateLeftAsideMenu({rootName: this.props.rootName});
        this.props.setStateLeftAsideMenu({rootName});
    }

    render() {
        const burgerMenuIsVisible =  this.props.rootName !== "HomeApp" && this.props.rootName !== "ReportsApp" && this.props.rootName !== "MasterApp" && this.props.rootName !== "HelpApp"
        return (
            <div className="header-mobile">
                <img src="/images/logo/logo_tek_smoll.jpg" className="max-h-30px" alt=""/>
                <div className="d-flex align-items-center">


                    <Link to="/" className={this.props.rootName === "HomeApp"
                        ? "nav-link btn btn-icon btn-light-success btn-sm mr-2 active"
                        : "nav-link btn btn-icon btn-light-success btn-sm mr-2"}>
                        <i className="svg-icon svg-icon-xl icon-Home"/>
                    </Link>


                    <Link to="/documents" className={this.props.rootName === "DocumentApp"
                        ? "nav-link btn btn-icon btn-light-success btn-sm mr-2 active"
                        : "nav-link btn btn-icon btn-light-success btn-sm mr-2 "}>
                        <i className="svg-icon svg-icon-xl icon-Documents"/>
                    </Link>

                    <Link to="/packages" className={this.props.rootName === "PackageApp"
                        ? "nav-link btn btn-icon btn-light-success btn-sm mr-2 active"
                        : "nav-link btn btn-icon btn-light-success btn-sm mr-2 "}>
                        <i className="svg-icon svg-icon-xl icon-Menu_pack"/>
                    </Link>

                    <Link to="/search" className={this.props.rootName === "SearchApp"
                        ? "nav-link btn btn-icon btn-light-success btn-sm mr-2 active"
                        : "nav-link btn btn-icon btn-light-success btn-sm mr-2 "}>
                        <i className="svg-icon svg-icon-xl icon-Search_menu"/>
                    </Link>

                    <Link to="/report" className={this.props.rootName === "ReportsApp"
                        ? "nav-link btn btn-icon btn-light-success btn-sm mr-2 active"
                        : "nav-link btn btn-icon btn-light-success btn-sm mr-2 "}>
                        <i className="svg-icon svg-icon-xl icon-reports"/>
                    </Link>

                    <Link to="/master" className={this.props.rootName === "MasterApp"
                        ? "nav-link btn btn-icon btn-light-success btn-sm mr-2 active"
                        : "nav-link btn btn-icon btn-light-success btn-sm mr-2"}>
                        <i className="svg-icon svg-icon-xl icon-Upload_document"/>
                    </Link>

                    <Link to="/help" className={this.props.rootName === "HelpApp"
                        ? "nav-link btn btn-icon btn-light-success btn-sm mr-2 active"
                        : "nav-link btn btn-icon btn-light-success btn-sm mr-2 "}>
                        <i className="svg-icon svg-icon-xl icon-Doc_view_6"/>
                    </Link>

                    <Link to="/messenger" className={this.props.rootName === "MessengerApp"
                        ? "nav-link btn btn-icon btn-light-success btn-sm mr-2 active"
                        : "nav-link btn btn-icon btn-light-success btn-sm mr-2 "}>
                        <i className="svg-icon svg-icon-xl bi bi-messenger"/>
                    </Link>

                    <span className={`nav-link btn btn-icon btn-success btn-sm mr-4 ${!burgerMenuIsVisible ? 'disabled' : ''}`} onClick={()=> burgerMenuIsVisible && this.toggleLeftMenu()}>
                        <i className="svg-icon svg-icon-xl icon-Table_grid"/>
                    </span>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = {
    setStateLeftAsideMenu
}


export default connect(mapStateToProps, mapDispatchToProps)(MobileMenu);
